(function () {
    angular.module('tmx-app').controller('SlsAndFrmuController', ['$scope', '$mdDialog', 'TMX_FINANCE_CONSTANTS', 'dynamicFormService', 'lookupService', 'tmxUtility', 'LocationService', 'cacheStore','tmxResource','ToastService','LoanApplicationService',

        function SlsAndFrmuController($scope, $mdDialog, TMX_FINANCE_CONSTANTS, dynamicFormService, lookupService, tmxUtility, LocationService,cacheStore,tmxResource,ToastService,LoanApplicationService) {
            var SlsAndFrmuVM = $scope;
            var exists;
            exists = tmxUtility.exists;
            SlsAndFrmuVM.FRMUData = {};
            SlsAndFrmuVM.applicationData = dynamicFormService.applicationData;
            SlsAndFrmuVM.MonthlyGrossIncomeIndex = null;
            SlsAndFrmuVM.OtherIncomeIndex = null;
            SlsAndFrmuVM.getValueByProductDataObj = getValueByProductDataObj;
            SlsAndFrmuVM.formatMonthYear = tmxUtility.formatMonthYear;
            SlsAndFrmuVM.getUniqueHistoryType = getUniqueHistoryType;
            SlsAndFrmuVM.showDbrTenureField = false;
            SlsAndFrmuVM.showCriteriaField = false;
            SlsAndFrmuVM.isPageLoading = false;
            SlsAndFrmuVM.slsformChange = slsformChange;
            SlsAndFrmuVM.sls = sls;
            SlsAndFrmuVM.frmu = frmu;
            SlsAndFrmuVM.ecib = ecib;
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
            var productId = SlsAndFrmuVM.applicationData.LoanProductId || SlsAndFrmuVM.applicationData.ProductId;
            var otherCompanyLkpId = "";
            var COMPANY_SEGMENT = [];
            var LoggedInUserConfigurations =  cacheStore.get("Configurations");	
            $scope.formatDate=tmxUtility.formatDateForCompany;
            if(SlsAndFrmuVM.applicationData.TmxCustomerMaster && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0]) {
                if(SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].SlsFlag==1)
                    SlsAndFrmuVM.SlsFlag =true;
                else
                    SlsAndFrmuVM.SlsFlag =false;
            
                if(SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].FrmuFlag==1)
                    SlsAndFrmuVM.FrmuFlag =true;
                else
                    SlsAndFrmuVM.FrmuFlag =false;
                if(SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].EcibFetchFlag==1)
                    SlsAndFrmuVM.EcibFlag =true;
                else
                    SlsAndFrmuVM.EcibFlag =false;
            }
            //#region  ----------Private Functions ----------------------------
            function getUniqueHistoryType(LoanDetails) {
                if (exists(LoanDetails) && exists(LoanDetails.TmxeCIBDetailHistoryMap)) {
                    var ecibHistoryType = LoanDetails.TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.map(a => a.HistoryType);
                    if (ecibHistoryType)
                        return ecibHistoryType.filter(onlyUnique);
                }
                return "";
            }

            function getValueByProductDataObj(product, date, obj) {
                if (obj.TmxeCIBDetailHistoryMap != null)
                    obj = obj.TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.filter(a => a.HistoryType == product && a.OverdueDate == date)[0];
                if (obj) {
                    return obj.Amount;
                }
                else {
                    return 0;
                }
            }
            function frmu(){
                SlsAndFrmuVM.isPageLoading = true;
                var SlsFrmuEligibilityParams = {};
                if (!(SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0] && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0] &&  SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer)) {
                    SlsAndFrmuVM.isPageLoading = false;
                    ToastService.showCustomToast('error', 'Please Enter Company Name');
                    return;
                }
                if (!SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue) {
                    SlsAndFrmuVM.isPageLoading = false;
                    ToastService.showCustomToast('error', 'Please Enter CNIC');
                    return;
                }
                if (!SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF) {
                    SlsAndFrmuVM.isPageLoading = false;
                    ToastService.showCustomToast('error', 'Please Enter Area Code');
                    return;
                }
                SlsFrmuEligibilityParams.CompanyName = SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                SlsFrmuEligibilityParams.CNIC = SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue;
                SlsFrmuEligibilityParams.AreaCode =SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF;
                tmxResource('Integration').getByAction('FRMU', false, 'post', SlsFrmuEligibilityParams).then(function (response) {
                    SlsAndFrmuVM.isPageLoading = false;
                    SlsAndFrmuVM.FrmuFlag = true;
                    SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].FrmuFlag = 1;
                    if (response.data.code == "00") {
                        var LookupByTypeAndHiddenValue = lookupService.getLookupByTypeAndHiddenValue(lkupType.COMPANY_SEGMENT, response.data.category);
                        if (LookupByTypeAndHiddenValue && LookupByTypeAndHiddenValue.length) {
                            response.data.category = LookupByTypeAndHiddenValue[0].LookupId;
                        }
                        if (response.data.approved_company != "") {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].FRMUStatus = "Cleared";
                            SlsFrmuEligibilityParams.NatureOfBusiness = response.data.category;
                            if (SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                                SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                            }
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = response.data.category;
                        }
                        else if (response.data.approved_company == "") {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].FRMUStatus = null;
                            SlsFrmuEligibilityParams.NatureOfBusiness = response.data.category;
                            if (SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                                SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                            }
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = response.data.category;
                        }
                        if (response.data.frmu != "") {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].FRMUStatus = "Black Listed";
                        }
                        else if (response.data.frmu == "" && response.data.approved_company == "") {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].FRMUStatus = null;
                        }
                        if (response.data.neg_cust != "") {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].negcustomer = true;
                        }
                        else if (response.data.neg_cust == "") {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].negcustomer = false;
                        }

                        if (response.data.neg_area != "") {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].negarea = true;
                        }
                        else if (response.data.neg_area == "") {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].negarea = false;
                        }
                        SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF = dynamicFormService.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF;
                        SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue = SlsFrmuEligibilityParams.CNIC;

                        if (SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                        }
                        SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer = SlsFrmuEligibilityParams.CompanyName;
                        $scope.$emit("reloadApplicationData",""); 
                    }
                });
            }
            function ecib(){
                SlsAndFrmuVM.isPaeLoading = true;
                var SlsFrmuEligibilityParams = {};
                SlsFrmuEligibilityParams.PersonDateOfBirth = SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth;
                SlsFrmuEligibilityParams.CNIC = SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue;
                if (SlsFrmuEligibilityParams.CNIC && SlsFrmuEligibilityParams.PersonDateOfBirth) {
                    
                    var DOB = tmxUtility.formatDateSpecific(SlsFrmuEligibilityParams.PersonDateOfBirth, "YYYY-MM-DD");
                    var ecib = {
                        CNIC: SlsFrmuEligibilityParams.CNIC,
                        DOB: DOB
                    };
                    LoanApplicationService.fetchEcib(ecib).then(function (response) {
                        SlsAndFrmuVM.isPaeLoading = false;
                        if (response.status.code == "200" && response.data && response.data.ECIBExtract != null) {
                            SlsAndFrmuVM.EcibFlag = true;
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].EcibFetchFlag = 1;
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxECIBDetail = response.data.ECIBExtract.LoanDetails;
                            SlsAndFrmuVM.ecibData = response.data.ECIBExtract;
                            $scope.$emit("reloadECIB",""); 
                            if (response.data.ECIBExtract.LoanDetails.length > 0) {

                                SlsAndFrmuVM.ecibLoanDetails = SlsAndFrmuVM.ecibData.LoanDetails;
                                SlsAndFrmuVM.ecibHistoryDateArray = SlsAndFrmuVM.ecibData.LoanDetails[0].TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.map(a => a.OverdueDate);
                                SlsAndFrmuVM.ecibHistoryDateArray = SlsAndFrmuVM.ecibHistoryDateArray.filter(onlyUnique);
                            }
                            else {
                                SlsAndFrmuVM.ecibLoanDetails = [];
                                SlsAndFrmuVM.ecibHistoryDateArray = [];
                            }
                        }
                        else if (response.status.code == "400") {
                            SlsAndFrmuVM.EcibFlag = false;
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].EcibFetchFlag = 0;
                            SlsAndFrmuVM.isPaeLoading = true;
                            ToastService.showCustomToast("default", response.status.message);
                            SlsAndFrmuVM.ecibLoanDetails = [];
                            SlsAndFrmuVM.ecibHistoryDateArray = [];
                        }
                        
                    });
                }
                else {
                    ToastService.showCustomToast("default", "Please Enter NIC and DOB");
                }
            }
            
            function sls(){
                SlsAndFrmuVM.isPageLoading = true;
                var SlsFrmuEligibilityParams = {};
                 
                if (!(SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0] && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0] && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail &&  SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer)) {
                    SlsAndFrmuVM.isPageLoading = false;
                    ToastService.showCustomToast('error', 'Please Enter Company Name')
                    return;
                }
                SlsFrmuEligibilityParams.CompanyName =SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                tmxResource('Integration').getByAction('SLS', false, 'post', SlsFrmuEligibilityParams).then(function (response) {
                    SlsAndFrmuVM.isPageLoading = false;
                    SlsAndFrmuVM.SlsFlag = true;
                    SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].SlsFlag = 1;
                    if (response.data.sls_status == 'Cleared') {
                        SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].SLSStatus = response.data.sls_status;
                        $scope.$emit("reloadApplicationData",""); 
                    }
                });
            }
            function slsformChange() {
                $scope.$emit("reloadApplicationData",""); 
            }

            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }


            function manipulateBtfFlag() {
                var x = angular.copy(SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxECIBDetail);
                if (x && x.length > 0) {
                    var maxDate = new Date(Math.max.apply(null, x.map(function (e) {
                        return new Date(e.CreatedDate);
                    })));
                    var diffInYears = moment(new Date()).diff(maxDate, 'years');

                    if (diffInYears < 1) {
                        var btfLkp = angular.copy(lookupService.getLocalLookupsByType(lkupType.BTF_GF));
                        SlsAndFrmuVM.BtfLkp = btfLkp.filter(function (a) {
                            return a.HiddenValue.toLowerCase() != 'gf'
                        });
                    }
                    else {
                        SlsAndFrmuVM.BtfLkp = angular.copy(lookupService.getLocalLookupsByType(lkupType.BTF_GF));
                    }
                }
            }
            function findPersonIncomeDetailIndex() {

                if (dynamicFormService.applicationData.TmxCustomerMaster && dynamicFormService.applicationData.TmxCustomerMaster[0] && dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail 
                    && dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0] && dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson && 
                    dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail && dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail.length) {
                    dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail.forEach(function (item, index) {
                        if (item.IncomeSourceLkp == 1) {
                            SlsAndFrmuVM.MonthlyGrossIncomeIndex = index;
                        }
                        else if (item.IncomeSourceLkp == 4) {
                            SlsAndFrmuVM.OtherIncomeIndex = index;
                        }
                    })
                }
                else {
                    dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail = [];
                    dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail.push(
                        {
                            IncomeSourceLkp: 1,
                            MonthlyIncomeAmount: 0
                        },
                        {
                            IncomeSourceLkp: 4,
                            MonthlyIncomeAmount: 0
                        }
                    )
                    SlsAndFrmuVM.MonthlyGrossIncomeIndex = 0;
                    SlsAndFrmuVM.OtherIncomeIndex = 1;
                }

            }

            function locationAreaPopulate() {
                SlsAndFrmuVM.LOCATION_TYPE_AREA = angular.copy(lookupService.getLocalLookupsByType(lkupType.LOCATION_TYPE_AREA));
            }
            function loadAreaCodeByCity(cityId) {
                if (cityId) {
                    SlsAndFrmuVM.LOCATION_TYPE_AREA = SlsAndFrmuVM.LOCATION_TYPE_AREA.filter(function (item) {
                        return item.ParentLookupId == cityId;
                    });
                }
                else {
                    SlsAndFrmuVM.LOCATION_TYPE_AREA = [];
                    SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF = null;
                }

            }

            function InitializeLookups() {
                lookupService.getLookupByType(lkupType.COMPANY).then(function (response) {
                    SlsAndFrmuVM.Company = response;


                    otherCompanyLkpId = SlsAndFrmuVM.Company.filter(function (obj) {
                        return obj.VisibleValue.toLowerCase() == 'other';
                    });
                    otherCompanyLkpId = otherCompanyLkpId[0] ? otherCompanyLkpId[0].LookupId : "";

                    SlsAndFrmuVM.Company.forEach(function (item) {
                        if (item.HiddenValue.toLowerCase() != 'other') {
                            item.LookupId = item.HiddenValue;
                        }
                    });

                    if (SlsAndFrmuVM.applicationData.TmxCustomerMaster[0] && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0] && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0] && SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer) {
                        var selectedCompanyName = SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                        var CompanyList = SlsAndFrmuVM.Company.filter(function (item) {
                            return item.HiddenValue == selectedCompanyName
                        });
                        if (CompanyList.length < 1) {
                            SlsAndFrmuVM.Company.push({
                                LookupId: selectedCompanyName,
                                HiddenValue: selectedCompanyName,
                                VisibleValue: selectedCompanyName
                            });
                        }
                    }
                });
                lookupService.getLookupByType(lkupType.COMPANY_SEGMENT).then(function (response) {
                    SlsAndFrmuVM.COMPANY_SEGMENT = response;
                    COMPANY_SEGMENT = angular.copy(SlsAndFrmuVM.COMPANY_SEGMENT);
                });


                lookupService.getLookupByType(lkupType.CUST_SEGMENT).then(function (response) {
                    SlsAndFrmuVM.CUST_SEGMENT = response;
                });

                lookupService.getLookupByType(lkupType.TYPE_OF_JOB).then(function (response) {
                    SlsAndFrmuVM.TYOE_OF_JOB = response;
                });
                lookupService.getLookupByType(lkupType.LOCATION).then(function (response) {
                    SlsAndFrmuVM.LOCATION = response;
                });
                lookupService.getLookupByType(lkupType.LOCATION_TYPE_CITY).then(function (response) {
                    SlsAndFrmuVM.LOCATION_TYPE_CITY = response;
                });
                SlsAndFrmuVM.IdentifierLkp = lookupService.getLocalLookupsByType(lkupType.ID_TYPE);

                SlsAndFrmuVM.CriteriaLkp = lookupService.getLocalLookupsByType(lkupType.CustomerCriteria);
            }

            function InitializeData() {
                if (exists(SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxECIBDetail)) {
                    SlsAndFrmuVM.ecibLoanDetails = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxECIBDetail;

                    var filteredList = SlsAndFrmuVM.ecibLoanDetails.find(x => x.TmxeCIBDetailHistoryMap);
                    if (exists(filteredList) && exists(filteredList.TmxeCIBDetailHistoryMap)) {
                        SlsAndFrmuVM.ecibHistoryDateArray = filteredList.TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.map(a => a.OverdueDate).filter(onlyUnique);
                    }

                }
                if (SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].CurCityUDF) {
                    $scope.CityUpdate(SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].CurCityUDF);
                }
                SlsAndFrmuVM.gridData = LocationService.activeLocations;
            }
            function ReadConfigurations(){
                SlsAndFrmuVM.showDbrTenureField =tmxUtility.getConfigurationValue(LoggedInUserConfigurations,'DBR_TENURE_MONTHS',true,productId) == true;
                SlsAndFrmuVM.showCriteriaField =tmxUtility.getConfigurationValue(LoggedInUserConfigurations,'SHOW_CRITERIA_SELECTION',true,productId) == true;
            }

            //#endregion


            //#region ------ Scope functions------------------
            $scope.SegmentUpdate = function (selectedValue) {
                if(dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0]){
                    dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = selectedValue;
                    SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = selectedValue;
                    $scope.$emit("reloadApplicationData",""); 

                }
            }

            $scope.CompanyUpdate = function (selectedValue) {

                // if(selectedValue == 'Other')
                if (selectedValue == otherCompanyLkpId) {
                    if (dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0]) {
                        dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = null;
                        SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = null;
                    }

                    SlsAndFrmuVM.COMPANY_SEGMENT = COMPANY_SEGMENT.filter(function (item) {
                        return item.ParentLookupId == otherCompanyLkpId
                    });

                    $scope.enableCompanySegment = true;
                    $mdDialog.show({
                        controller: SelectCompanyController,
                        templateUrl: 'common/pages/sls-and-frmu/select-company.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                    }).then(function (data) {
                        if (data) {
                            SlsAndFrmuVM.Company.push({
                                LookupId: data.CompanyName,
                                HiddenValue: data.CompanyName,
                                VisibleValue: data.CompanyName
                            });

                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer = data.CompanyName;
                        }
                        else {
                            SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer = null;
                        }
                    });
                }
                else if (selectedValue == null) {
                    $scope.enableCompanySegment = false;
                    SlsAndFrmuVM.COMPANY_SEGMENT = COMPANY_SEGMENT;
                }
                $scope.$emit("reloadApplicationData",""); 
            }

            $scope.CityUpdate = function (cityId) {
                locationAreaPopulate();
                loadAreaCodeByCity(cityId);
            }

            $scope.concatenatePersonNames= function(){
                var names = [
                    SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonFirstName,
                    SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonMiddleName,
                    SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonLastName
                ];
                SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].CustomerName = names.join(' ');
                $scope.$emit("reloadApplicationData",""); 
            }

            //#endregion

            $scope.$on("reloadSlsAndFrmuData", function () {
                
                SlsAndFrmuVM.applicationData = dynamicFormService.applicationData;
                if(SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].SlsFlag==1)
                    SlsAndFrmuVM.SlsFlag = true;
                else
                    SlsAndFrmuVM.SlsFlag = false;
                findPersonIncomeDetailIndex();
                manipulateBtfFlag();
                // $scope.resourceForEcibGrid = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxECIBDetail;
                if (!SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness) {
                    SlsAndFrmuVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = null;
                }
            });

            (function InitializePage(){
                InitializeData();
                InitializeLookups();
                ReadConfigurations();
                manipulateBtfFlag();
                findPersonIncomeDetailIndex();
            })();

            //#region -----Child controllers-----------

            function SelectCompanyController($scope) {
                $scope.data = {};
                $scope.ok = function () {
                    $mdDialog.hide($scope.data);
                }
                $scope.cancel = function () {
                    $mdDialog.hide();
                }
            }

            // eslint-disable-next-line no-unused-vars
            function SelectAreaCodeController($scope) {
                $scope.data = {};
                $scope.ok = function () {
                    $mdDialog.hide($scope.data);
                }
                $scope.cancel = function () {
                    $mdDialog.hide();
                }
            }

            //#endregion

        }]);
})();